import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import appConfigSelectors from 'modules/appConfig/selectors';

/**
 * loads AcceptJs script
 * @returns isAcceptJsReady
 */
const useLoadAcceptJs = (enabled: boolean) => {
	const { src: acceptJsSrc } = useSelector(
		appConfigSelectors.getAcceptJsConfig,
	);
	const [isAcceptJsReady, setAcceptJsReady] = useState(false);

	useEffect(() => {
		if (!enabled) return undefined;

		if (window.Accept) {
			setAcceptJsReady(true);
			return undefined;
		}

		// Create and inject script
		const script = document.createElement('script');
		script.src = acceptJsSrc;
		script.async = true;
		script.onload = () => {
			setAcceptJsReady(true);
		};

		document.head.appendChild(script);

		// Cleanup function
		return () => {
			// Remove script if component unmounts before loading
			if (script.parentNode) {
				script.parentNode.removeChild(script);
			}
		};
	}, [enabled, acceptJsSrc]);

	return isAcceptJsReady;
};

export default useLoadAcceptJs;
